module.exports = __webpack_public_path__ + "static/img/bgrule2.2ec1546.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bgrule2.png
// module id = yU5B
// module chunks = 1